import { render, staticRenderFns } from "./HealthSciencePopularization.vue?vue&type=template&id=60d5d30e&scoped=true&"
import script from "./HealthSciencePopularization.vue?vue&type=script&lang=js&"
export * from "./HealthSciencePopularization.vue?vue&type=script&lang=js&"
import style0 from "./HealthSciencePopularization.vue?vue&type=style&index=0&id=60d5d30e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60d5d30e",
  null
  
)

export default component.exports